// extracted by mini-css-extract-plugin
export const infoDelivery = "delivery-module--infoDelivery--20_74";